// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Get_DELIVERY_MODEL } from '@store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupDELIVERYMODEL = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    dispatch(Get_DELIVERY_MODEL());
  }, []);

  const { DELIVERY_MODEL, loading, error } = useSelector(state => state.Lookup);

  const OptionsDELIVERY_MODEL =
    DELIVERY_MODEL &&
    DELIVERY_MODEL?.map((item, idx) =>
      item.list?.map(list => ({
        value: list.lookupCode,
        label: i18n.language === 'en' ? list.meaning : list.meaning2
      }))
    ).flat();

  return { DELIVERY_MODEL, OptionsDELIVERY_MODEL, loading, error };
};

export default useLookupDELIVERYMODEL;
